var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LeftBuildContainer"},[_c('ContentTop',{attrs:{"title":"赛事活动排名","topOptionsProps":_vm.cityActiveOptionProps,"type":2}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"21px"}},[_c('rank-list',{attrs:{"view-type":"other","listHeight":323,"list":_vm.areaData}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }